export class Order {
}
export class OrderLine {
}
export var TicketStatus;
(function (TicketStatus) {
    TicketStatus["pending"] = "Pending";
    TicketStatus["ready"] = "Ready";
})(TicketStatus || (TicketStatus = {}));
